const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsSecuritySpecialty = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Designing Secure Cloud Architectures on AWS
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          With the AWS Certified Security – Specialty certification, I design systems where
          security is built into every layer — from infrastructure and access control to data protection and monitoring.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsSecurityBadge.png"
          alt="AWS Certified Security Specialty"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified Security – Specialty
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Security is not an add-on — it is a fundamental part of system architecture.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          This certification reflects deep expertise in designing secure cloud environments,
          implementing best practices, and ensuring systems remain resilient against threats.
        </p>
      </div>


      {/* CAPABILITIES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Security Capabilities I Can Deliver
        </h2>

        <div style={gridStyle}>
          {[
            "Designing IAM strategies with least-privilege access principles",
            "Implementing secure authentication and authorization models",
            "Encrypting data at rest and in transit using AWS KMS and secure protocols",
            "Designing secure network architectures within VPC environments",
            "Implementing logging, monitoring, and auditing mechanisms",
            "Detecting and responding to threats using AWS security services",
            "Securing serverless and event-driven architectures",
            "Integrating security controls into CI/CD pipelines",
            "Designing compliant and audit-ready cloud environments"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* SECURITY DOMAINS 🔥 */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          Security Across All Layers
        </h2>

        <div style={gridStyle}>
          {[
            "Identity and access management (IAM roles, policies, federation)",
            "Data protection (encryption, key management, secure storage)",
            "Network security (VPC design, endpoints, traffic control)",
            "Application security (API protection, validation, isolation)",
            "Monitoring and auditing (CloudTrail, logs, alerts)",
            "Threat detection and response (GuardDuty, Security Hub)"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* USE CASES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Where This Creates Real Value
        </h2>

        <div style={gridStyle}>
          {[
            "Securing production AWS environments",
            "Designing compliant systems (GDPR, enterprise standards)",
            "Protecting sensitive data and business-critical systems",
            "Reducing risk of breaches and misconfigurations",
            "Improving visibility and control over cloud environments",
            "Building trust in cloud-based applications"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Secure systems are not built by adding controls at the end —
          they are designed with security in mind from the very beginning.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          I integrate security into architecture, development, and operations to ensure
          systems remain resilient, compliant, and trustworthy.
        </p>
      </div>


      {/* CTA 🔥 */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Secure Your AWS Architecture
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s design and implement a secure foundation for your cloud systems.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your Security Architecture →
        </a>
      </div>

    </div>
  );
};

export default AwsSecuritySpecialty;